import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConnectedLocationAutocomplete } from 'shared/components';

import { ReasonInputBaseProps } from './BaseInput';
import FieldFreeText from './FieldFreeText';

export default function LocationInput(props: ReasonInputBaseProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails.reasonInput.location' });
    const { control } = props;

    return (
        <>
            <Typography variant="subtitle2">{ t('label') }</Typography>
            <ConnectedLocationAutocomplete control={ control }
                name="reasonInput.locationKey" />
            <FieldFreeText control={ control } />
        </>
    );
}
